import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class Trade extends Resource {
    public override type = 'trades';

    @prop()
    public name!: string;

}